import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_GET_RECHERCHE_ARMES,
    CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
} from '../../constants/apiUrls.constants';
import { ArmeLoaderReducer } from './loader/armeLoaderReducer';

const recherche = combineReducers({
    armes: APIReducer.bind(null, CONTEXT_GET_RECHERCHE_ARMES),
    armeLoader: ArmeLoaderReducer,
    armesQuotaMunitions: APIReducer.bind(null, CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS),
});

export default recherche;
